<template>
    <div v-if="hasAvailability" class="availability-wrapper">
        <div class="availability-grid">
            <div
                v-for="(monthLabel, statusKey) in monthNames"
                :key="statusKey"
                class="availability-month"
            >
                {{ monthLabel }}
                <ToolTipIcon 
                    :content="getAvailabilityInfo(availability[statusKey]).label" 
                    :iconClass="getAvailabilityInfo(availability[statusKey]).iconClass"
                 />
            </div>
        </div>
        <div class="availability-helper-text">
            Use the availability calendar as a guide because availability may differ due to weather, country of origin, grower, and other factors.
        </div>
    </div>
</template>
<script setup>
import { computed } from 'vue';
import ToolTipIcon from './ToolTipIcon.vue';

const props = defineProps({
    availability: {
        type: Object,
        required: true,
    },
});

const monthNames = {
    january_status: 'Jan',
    february_status: 'Feb',
    march_status: 'Mar',
    april_status: 'Apr',
    may_status: 'May',
    june_status: 'Jun',
    july_status: 'Jul',
    august_status: 'Aug',
    september_status: 'Sep',
    october_status: 'Oct',
    november_status: 'Nov',
    december_status: 'Dec',
};

const availabilityStates = [
    { status: 0, label: 'Not Available', iconClass: 'fa-solid fa-xmark text-danger' },
    { status: 1, label: 'Available', iconClass: 'fa-solid fa-check text-green' },
    { status: 2, label: 'Limited', iconClass: 'fa-solid fa-triangle-exclamation text-warning' },
];

const hasAvailability = computed(() =>
    props.availability != null &&
    Object.keys(monthNames).some((key) => props.availability[key] != null && props.availability[key] !== '')
);

function getAvailabilityInfo(status) {
    const numericStatus = Number(status);
    const state = availabilityStates.find((s) => s.status === numericStatus);
    return state
        ? { label: state.label, iconClass: state.iconClass }
        : { label: 'Unknown', iconClass: 'fa-solid fa-question text-secondary' };
}
</script>
<style scoped>
.availability-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
}
.availability-month {
    border: 1px solid #e4e4e4;
    border-bottom: none;
    display: flex;
    padding: var(--padding-10);
    flex-direction: column;
    align-items: center;
    gap: var(--gap-5);
    justify-self: stretch;
    font-size: var(--font-size-md);
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
}
.availability-month:nth-last-child(-n+3) {
    border-bottom: 1px solid #e4e4e4;
}
.availability-month:hover {
    box-shadow: 0px 20px 30px -30px black, 0px -10px 30px -30px black;
}
.availability-month :deep(.tooltip-info-icon-wrap) {
    line-height: 1;
    width: 14px;
    height: 14px;
    display: inline-block;
}
.availability-month :deep(.tooltip-icon) {
    width: 14px;
    height: 14px;
}
.availability-helper-text {
    color: #000;
    font-size: var(--font-size-sm);
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    margin-top: var(--gap-10);
}
.min-height-45 {
    min-height: 45px;
}

@media screen and (min-width: 992px) {
  .availability-grid {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }  
    .availability-month {
        border-bottom: 1px solid #e4e4e4;   
    }
}
</style>
